import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBg from '../../../images/ComponentImages/categoryScreenBackground.png';
import RoundScreen from '../../../components/roundScreen';

export default function Page10({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen titles={['Day 3', 'Chest CCMRs']} BGImage={CategoryScreenBg} />
			<RoundScreen
				title='Run 6 Rounds'
				isNumberd={true}
				rounds={[
					[
						{header: 'Type', value: 'ALPHA'},
						{header: 'C.C.M.R’s', value: 'DUMBBELL PRESS'},
						{header: 'REPS Sec / Min', value: '6 - 8'},
						{header: 'WEIGHT LEVEL', value: 'Mild -> Heavy'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'RESISTANCE BAND FLYES'},
						{header: 'REPS Sec / Min', value: '10'},
						{header: 'WEIGHT LEVEL', value: 'Light -> Mild'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'BURPEES'},
						{header: 'REPS Sec / Min', value: '10'},
						{header: 'WEIGHT LEVEL', value: 'Explosive Movement'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'PUSHUPS'},
						{header: 'REPS Sec / Min', value: '10'},
						{header: 'WEIGHT LEVEL', value: 'BodyWeight'},
					],
				]}
			/>
			<p style={style.takeABreakTextStyle()}>Take a 1 - 2 minute break</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
